import { render, staticRenderFns } from "./PackagePitch.vue?vue&type=template&id=0179f9ef&scoped=true&"
import script from "./PackagePitch.vue?vue&type=script&lang=js&"
export * from "./PackagePitch.vue?vue&type=script&lang=js&"
import style0 from "./PackagePitch.vue?vue&type=style&index=0&id=0179f9ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0179f9ef",
  null
  
)

export default component.exports